<template>
  <div id="footer" class="container-fluid">
    <div class="row container footer-top">
      <div class="col-xs-12 col-sm-12 col-md-6" style="display: flex;justify-content: space-between">
        <div class="menu">
          <p @click="routerTo('/companyintroduction')">{{ $t('header.aboutUs') }}</p>
          <p @click="routerTo('/software')">{{ $t('header.productService') }}</p>
          <p @click="routerTo('/service')">{{ $t('header.rdCenter') }}</p>
          <p @click="routerTo('/contactus')">{{ $t('header.contactUs') }}</p>
        </div>
        <!--<div class="qr-code">
          <div>
            <img width="96px" height="96px" src="../assets/img/QRcode.png" alt="">
            <span>BOSS直聘</span>
          </div>
          <div>
            <img width="96px" height="96px" src="../assets/img/QRcode.png" alt="">
            <span>微信公众号</span>
          </div>
        </div>-->
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 register">
        <span>{{ $t('footer1') }}</span>
        <span>{{ $t('footer2') }}</span>
        <div style="display: flex">
          <input type="text" class="form-control" :placeholder="$t('footer5')">
          <button class="btn btn-primary">{{ $t('footer3') }}</button>
        </div>
      </div>
    </div>

    <p class="row address_tel_fax">
      <span class="col-xs-12 col-sm-12 col-md-6">{{ copyrightText }}</span>
      <span class="col-xs-12 col-sm-12 col-md-6 copy" @click="openUrl">{{ icpNo || '苏ICP备2024061325号-1' }}</span>
    </p>
  </div>
</template>
<script>
import api from '@/api/api'
export default {
  name: "Footer",
  data() {
    return {
      icpNo: '',
      copyrightZh: '',
      copyrightEn: ''
    };
  },
  computed: {
    copyrightText() {
      if (this.$i18n.locale === 'en') return this.copyrightEn || this.$t('footer4')
      return this.copyrightZh || this.$t('footer4')
    }
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    async loadConfig() {
      try {
        var kv = await api.configAll();
        this.icpNo = (kv['icp_no'] || {}).value || '';
        this.copyrightZh = (kv['copyright_zh'] || {}).value || '';
        this.copyrightEn = (kv['copyright_en'] || {}).value || '';
      } catch (e) { /* ignore */ }
    },
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    openUrl(url) {
      window.open('https://beian.miit.gov.cn')
    },
    routerTo(url) {
      this.$router.push(url)
      this.GoTop()
    }
  }
};
</script>
<style scoped>
.container {
  padding: 0;
}

#footer {
  width: 100%;
  height: 100%;
  color: #484848;
  background: #f0f0f0;
  overflow: hidden;
  text-align: center;
}
.menu {
  text-align: left;
  padding: 40px 0 0;
}
.menu p {
  font-size: 16px;
  line-height: 30px;
  cursor: pointer;
}
.menu p:hover {
  color: #093a92;
}
.menu p:not(:first-child) {
  cursor: pointer;
}
.footer-top {
  border-bottom: 1px solid #c5c5c9;
  margin: auto;
}
.qr-code {
  display: flex;
  justify-content: flex-end;
  margin-top: 63px;
  font-size: 15px;
}
.qr-code img {
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 6px;
}
.qr-code div:first-child {
  margin-right: 20px;
}
.register {
  text-align: left;
  padding: 55px 0 0 50px;
}
.register span:first-child {
  font-size: 24px;
  padding: 0 10px 0 3px;
}
.register span:last-child {
  font-size: 16px;
}
.register input {
  background: #fff;
  margin-top: 10px;
  height: 45px;
  border: none;
  color: #fff;
  border-radius: 0;
}
.register input:focus {
  box-shadow: none;
}
.register button {
  background: #093a92;
  border: none;
  height: 45px;
  margin-top: 10px;
  border-radius: 0;
  font-size: 18px;
}
.register button:focus {
  border: none;
  outline: none;
}
.address_tel_fax {
  color: #6e6d78;
  font-size: 14px;
  margin: 10px 0;
}
.address_tel_fax span:first-child {
  text-align: right;
}
.address_tel_fax span:last-child {
  text-align: left;
}
.copy {
  color: #6e6d78;
  font-size: 14px;
  cursor: pointer;
}
@media screen and (max-width: 997px) {
  .address_tel_fax {
    font-size: 12px;
  }
  .address_tel_fax span {
    text-align: center;
  }
  .register {
    padding: 10px 0;
  }
  .copy {
    font-size: 12px;
    margin: 10px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue